module.exports = __webpack_public_path__ + "images/emoji/gem.7c879f3d02703c3b200e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/gem.png
// module id = Hx9M
// module chunks = 14